<template>
    <div class="p_demand_plan">
        <el-steps :active="active" finish-status="success" class="steps-box">
          <el-step title="基础信息"></el-step>
          <el-step title="上传导入文件"></el-step>
          <el-step title="导入处理"></el-step>
        </el-steps>
        <div v-if="active==0" style="margin-top:15px;padding-bottom:15px;">
          <div class="flex">
            <div>
              <div>导入表格:</div>
              <div class="storageArea">
                <div class="storageInput" style="margin:0 20px 0 0">
                  <el-select v-model="tabName" slot="prepend" placeholder="请选择" disabled filterable @change="selectTab">
                    <el-option v-for="(item, index) in this.tableList" :key="index" :label="item.StrTableName" :value="{value:item.StrTableId,label:item.StrTableName}"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="margin-left:150px">
              <div>导入模板下载:</div>
              <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;margin-top:10px">下载模板</el-button>
            </div>
          </div>
        </div>
        <div v-if="active==1" style="margin-top:15px;padding-bottom:15px;">
          <div class="note-txt">
            <p style="font-weight:bold;">上传文件说明：</p>
            <p>1. 支持文件后缀 xls、xlsx文件。</p>
            <p>2. 请将要上传的内容放在第一个sheet中。</p>
            <p>3. 请不要加密模板文件，将导致错误。</p>
            <p>4. 请不要上传带宏的文件，将导致错误。</p>
            <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。</p>
            <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
          </div>
          <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
          <div class="form-item" style="justify-content: space-between;">
            <div class="file-box">
              <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn">上传</label>
            </div>
            <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载模板</el-button>
          </div>
          <!-- 提示 -->
          <p style="color:red;" v-if="isError">{{errorTxt}}</p>
          <div class="reimpArea">
            <div style="margin-top:10px">
              <!-- <el-checkbox v-model="isReset" @change="selectReimp">是否覆盖导入</el-checkbox> -->
            </div>
          </div>
        </div>
        <div v-if="active==2" style="margin-top:15px;padding-bottom:15px;">
          <div class="result-box">
            <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;-webkit-justify-content:flex-end;padding-bottom: 30px;">
          <!-- <el-button size="small" @click="dialogVisible5 = false" v-if="active==0">取消</el-button> -->
          <el-button size="small" @click="prevSteps" v-if="active>0 && active<=1">上一步</el-button>
          <el-button type="primary" class="com_dialog_btn" size="small" @click="nextSteps" v-if="active<1">下一步</el-button>
          <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请等待..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-if="active==1" :disabled="isUploadSuccess">提交</el-button>
          <!-- <el-button type="primary" size="small" @click="backHandle" v-if="active==2">确认并返回</el-button>
          <el-button size="small" @click="resultHandle" v-if="active==2">查看导入结果</el-button> -->
        </div>
    </div>
</template>
<script>
import xz from "./../../../common.vue";
import FUN from "./../../../fun";
export default {
  props: {
    typeName:{
      type:String
      // default:''
    }
  },
    data() {
        return {
            active: 0,
            tabName: { label: "简历导入表", value: "JB_busi_PsnBaseImp" },
            tableList: [{
                StrTableId: "JB_busi_PsnBaseImp",
                StrTableName: "简历导入表"
            }],
            tablePath: this.$store.state.EMP.tablePath,
            ExcelSrc: {
                value: '',
                check: false,
                fileName: ''
            },
            excelpath: '',
            entid: '',
            isUploadSuccess: false,
            fullscreenLoading: false,
            errorTxt: '',
            //是否下载过导入模板
            isDownResTemplate: false,
            //表头错误提示
            isError: false
        }
    },
    created() {
      // console.log('typeName',this.typeName)
      if (window.localStorage.getItem('isDownResTemplate')) {
        this.calDaysBetween(window.localStorage.getItem('isDownResTemplate'))
      }
    },
    methods: {
        // 下拉选择表格
        selectTab(d) {
            this.tabId = d.value
            this.tabName = d.label
            // console.log("d", d);
        },
        calDaysBetween(date) {
            let startDate = Date.parse(date);
            let endDate = Date.parse(new Date());
            let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
            days > 7 ? this.isDownResTemplate = false : this.isDownResTemplate = true;
        },
        //下一步导入
        nextSteps() {
            // if (this.active++ > 2) this.active = 0;
            if (this.active == 0) {
                if (this.tabName == '') {
                    this.$message({
                        message: "请选择导入模板",
                        type: "warning"
                    });
                    this.active = 0
                return false
                }
                if (!this.isDownResTemplate) {
                    this.$message({
                        message: "请先下载导入模板，下一步导入请使用新的模板导入",
                        type: "warning",
                        duration: 5000
                    });
                    return false
                }
            }
            this.active += 1
        },
        //上一步导入
        prevSteps() {
            this.active -= 1
        },
        //提交导入
        async lastSteps() {
            if (this.ExcelSrc.value == '') {
                this.isUploadSuccess = true
                this.$message({
                message: "请选择文件上传",
                type: "warning"
                });
                this.active = 1
                return false
            }else {
                //检查表头是否正确
                let checkData = {
                    excelpath: this.excelpath,
                    tableid: "JB_busi_PsnBaseImp",
                    fileid: '简历导入表'
                }
                // console.log('checkData', checkData)
                this.fullscreenLoading = true;
                xz.chkPsnTableForm(checkData).then(res => {
                // console.log('checkData',res)
                // //第一个冒号出现的位置
                // let firstIndex = res.indexOf(":")
                // //根据第一个点的位置 获得第二个点的位置
                // let secondIndex = res.indexOf(":", firstIndex + 1)
                // //根据第二个点的位置，截取 字符串。
                // let resultTxt = res.slice(Number(secondIndex + 2), -2)
                let resultTxt = res.msg
                // console.log('resultTxt',this.isNull(res))
                if (this.isNull(res.msg)) {
                    this.isError = false
                    this.isUploadSuccess = false
                    const Edata = {
                    instname: this.instname,
                    tableid: "JB_busi_PsnBaseImp",
                    // impexcel:"简历导入表",
                    reimp: this.reimp,
                    excelpath: this.excelpath,
                    impexcel: this.ExcelSrc.fileName,
                    servusrname: this.StrUserName,
                    servcentname: this.typeName,//个人资源简历   公海资源简历
                    custname: this.StrObjName,
                    fileid: '简历导入表'
                    }
                    xz.psnAnlysisExcelInf(Edata).then(res => {
                        // console.log('Edata', res)
                        if (res.status == 'ok') {
                            this.active = 2
                            // 向父组件传值
                            this.$emit('changeDialog',2);
                        } else {
                            this.$message('导入错误');
                        }
                        this.fullscreenLoading = false;
                        // this.isUploadSuccess = true
                    })
                } else {
                    this.isError = true
                    this.active = 1
                    this.isUploadSuccess = true
                    this.errorTxt = resultTxt
                    //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
                    //清空input file值
                    var file = document.getElementById("fileInput");
                    file.value = '';
                    this.fullscreenLoading = false;
                }
                })
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
        },
        //下载模板
        downLoadHandle() {
            xz.getPsnOutPutMode().then(res => {
                // console.log('下载模板', res)
                if (res) {
                    this.isDownResTemplate = true;
                    window.localStorage.setItem('isDownResTemplate', new Date());
                    var d = res.msg.data.StrOutPath
                    d = d.replace("\"", "").replace("\"", "")
                    var path = this.tablePath + d
                    const aTag = document.createElement('a')
                    aTag.href = path
                    aTag.click();
                }
            })
        },
        // //导入-确认返回
        // backHandle() {
        //     // this.dialogVisible5 = false
        //     // this.$parent.getList();
        // },
        // //查看导入结果
        // resultHandle() {
        //     // this.dialogVisible5 = false
        //     this.$router.push({
        //         path: "/resImportList"
        //     })
        // },
        //文件读取
        async importf() {
            const fileInput = this.$refs.upload;
            this.excelpath = ''
            FUN.returnExcelSrc(fileInput).then(src => {
                if (src) {
                // console.log('src0o0', src)
                this.isFileSuccess = true
                this.$set(this.ExcelSrc, "value", src.src);
                this.$set(this.ExcelSrc, "check", false);
                this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
                // console.log('srccc', this.ExcelSrc)
                //上传excel
                const excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
                const formData = new FormData();
                formData.append("pagename", 'empexcel');
                formData.append("action", 'save');
                formData.append("userid", Cookies.get("userid-b"));
                formData.append("entid", Cookies.get("userid-b"));
                formData.append("excel", excelFile, this.ExcelSrc.fileName);
                // console.log('formData', formData)
                xz.uploadCert(formData).then(res => {
                    // console.log('formData', res)
                    if (this.isNull(res) || res == false) {
                        this.$message('上传Excel失败!')
                        this.isUploadSuccess = true
                    } else {
                        this.errorTxt = ''
                        this.excelpath = res;
                        this.isUploadSuccess = false
                        this.$refs['upload'].value = null;
                    }
                });
                } else {
                    this.$message('上传Excel失败!')
                }
            })
        }
    }
}
</script>

<style scoped>
.com_dialog_btn.el-button{
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19BD92;
  font-weight: bold;
}
.com_dialog_btn.el-button:hover{
  background-color: #19BD92;
  border: 1px solid #62d2b4;
  color: #fff;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: absolute;
    top: 5px;
    right: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>